import Vue from "vue";
import Router from "vue-router";

// Containers
import Cookies from "js-cookie";
import Full from "@/containers/Full";

// Views
import Dashboard from "@/views/Dashboard.vue";
import LoginForm from "@/views/LoginForm.vue";
import store from "@/store";

Vue.use(Router);

const forceLogin = false;

const router = new Router({
  mode: "hash",
  linkExactActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      meta: {
        label: "S232"
      },
      component: Full,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          meta: {
            label: "S258"
          },
          component: Dashboard
        },
        {
          path: "create/project/:modality",
          name: "CreateProject",
          meta: {
            label: "S258"
          },
          component: () => import("@/views/apps/CreateProjectView") // CreateProjectView
        },
        {
          path: "project/:modality/:projectId",
          name: "ViewProject",
          meta: {
            label: "S258"
          },
          component: () => import("@/views/apps/ProjectView") //ProjectView
        },
        {
          path: "switch/project/:modality/:projectId",
          name: "SwitchProject",
          meta: {
            label: "S258"
          },
          component: () => import("@/views/apps/ProjectViewSwitcher") //ProjectViewSwitcher
        },
        {
          path: "languages",
          name: "Translation", //ProjectViewSwitcher
          component: () => import("@/components/management/TranslationsManagement.vue") //RegisterForm,
        },
        {
          path: "managementtabs",
          name: "ManagementTabs",
          component: () => import("@/components/management/ManagementTabs.vue")
        },
        {
          path: "printout",
          name: "Printout",
          component: () => import("@/views/apps/Printout")
        }
      ]
    },
    {
      path: "/login",
      component: LoginForm,
      name: "LoginForm"
    },
    {
      path: "/register",
      component: () => import("@/views/RegisterForm.vue"), //RegisterForm,
      name: "RegisterForm"
    }
  ]
});

router.beforeEach((to, from, next) => {
  var isLoggedIn = Cookies.get("loginToken"); //MARCO DC 26/09/2022 => cambiato da const a var

  var url = new URL(window.location.href);

  if (to.path != "/login" && to.path != "/register") {
    var isAdmin = store.getters["_authModule/isAdmin"];
    var isUnilab = store.getters["_authModule/isUnilab"];

    var lang = url.searchParams.get("lang") + "";
    var bForced = lang != "null";
    lang = lang == "null" ? "en-US" : lang;

    store.commit("_translationModule/CHANGE_LANGUAGE", lang);
    store.commit("_translationModule/SET_BFORCED", bForced);

    if (to.path == "/managementtabs" && isLoggedIn) {
      isLoggedIn = isAdmin || isUnilab;

      if (isLoggedIn == false) {
        Cookies.remove("loginToken");
      }
    }
    if (isLoggedIn) {
      store.commit("_commonModule/IS_IN_MANAGEMENT", to.path == "/managementtabs");

      next();
    } else {
      next("/login");
    }
  } else {
    if (from.path != to.path) {
      // console.log("You're on the login / register page");

      var id = url.searchParams.get("userId");

      store.commit("_authModule/SET_CORDIVARI_ID", id);

      next(); // This is where it should have been
    }
  }
  // next()
});

export default router;
